var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"list-foot",staticStyle:{"font-size":"14px"}},[_vm._t("default",[_vm._v("到底了~")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }